module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIuMTIxMzEiIGhlaWdodD0iMTQuODQ5MiIgdHJhbnNmb3JtPSJtYXRyaXgoMC43MDcxMDcgMC43MDcxMDYgLTAuNzA3MTA3IDAuNzA3MTA2IDEwLjUgMCkiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHdpZHRoPSIyLjEyMTMxIiBoZWlnaHQ9IjE0Ljg0OTIiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjcwNzEwNyAwLjcwNzEwNiAtMC43MDcxMDcgLTAuNzA3MTA2IDEyIDEwLjUpIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/close-white.svg
// module id = fPoJ
// module chunks = 38